import { ButtonType } from '@fluentui/react';
import { forwardRef, Ref, useState } from 'react';

import { singleOrArrayToArray } from '../../utils/utils';
import { Button, IButtonProps } from '../Button/Button';
import {
  buttonStylesIconInlineBlock,
  buttonStylesIconInlineBlockSuccess,
  buttonStylesInlineRight,
  buttonStylesInlineRightSuccess,
} from '../Button/Button.styles';

export interface IClipboardButtonProps extends IButtonProps {
  content: string | undefined;
  block?: boolean;
}

export const ClipboardButton = forwardRef(
  ({ content, styles, block = false, ...rest }: IClipboardButtonProps, ref: Ref<HTMLDivElement>) => {
    const [copySuccess, setCopySuccess] = useState<string>('Copy'),
      copyToClipboard = (value: string | undefined): void => {
        navigator.clipboard
          .writeText(value || '')
          .then(() => {
            setCopySuccess('SkypeCircleCheck');
            setTimeout(() => setCopySuccess('Copy'), 2000);
          })
          .catch((err) => {
            // clipboard requires a secure context like `https://` or `localhost` or `127.0.0.1`. if not, it will not allow to use the clipboard.
            console.warn(err.message);
          });
      },
      copy = copySuccess === 'Copy',
      internalStyles = block
        ? copy
          ? [buttonStylesIconInlineBlock]
          : [buttonStylesIconInlineBlock, buttonStylesIconInlineBlockSuccess]
        : copy
        ? [buttonStylesInlineRight]
        : [buttonStylesInlineRight, buttonStylesInlineRightSuccess],
      allStyles = [...internalStyles, ...singleOrArrayToArray(styles)];

    return (
      <Button
        ref={ref}
        styles={allStyles}
        buttonType={ButtonType.icon}
        title={copySuccess === 'Copy' ? 'Click to copy to clipboard' : 'Copied!'}
        iconName={copySuccess}
        onClick={() => copyToClipboard(content)}
        {...rest}
      />
    );
  }
);
